import {get, post, postJson} from '../axios'
// 精准营销

// const RESOURCE_BASE_PATH = '/jd-yusms'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms'
const RESOURCE_BASE_PATH = '/public/getShortLink'


// 获取短连接
export const getShortLink = p => get(`${RESOURCE_BASE_PATH}/`, p);


